/* Panda's Box – Diwali 2026 landing page behaviours (fireworks, sliders, marquee helpers, copy-code, sub-nav). */
(function () {
  if (window.__pb26) { window.__pb26.init(document); return; }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- fireworks ---------------- */
  function fireworks(cv) {
    var every = parseInt(cv.getAttribute('data-interval'), 10) || 1000;
    var cols = (cv.getAttribute('data-colors') || '#CA2C2C,#FC7059,#F4777C,#2F91D4,#ffffff,#FFA800').split(',');
    var ctx = cv.getContext('2d');
    var w = 0, h = 0, raf, last = 0, acc = every * 0.6, visible = false, cleared = true;
    var rockets = [], sparks = [];
    function resize() { var r = cv.getBoundingClientRect(); w = r.width; h = r.height; cv.width = w; cv.height = h; }
    resize();
    var ro = new ResizeObserver(resize); ro.observe(cv);
    var io = new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }); io.observe(cv);
    function pick() { return cols[Math.floor(Math.random() * cols.length)]; }
    function launch() {
      var zones = w < 700 ? [[0.06, 0.26], [0.74, 0.94]] : [[0.04, 0.3], [0.5, 0.97], [0.55, 0.95]];
      var z = zones[Math.floor(Math.random() * zones.length)];
      var x = w * (z[0] + Math.random() * (z[1] - z[0]));
      var ty = h * (0.1 + Math.random() * 0.32);
      rockets.push({ x: x, y: h, ty: ty, vy: -(h - ty) / 42, c: pick() });
    }
    function burst(x, y, c) {
      if (sparks.length > 450) return;
      var n = 40 + Math.floor(Math.random() * 30), sp = 1.8 + Math.random() * 2, c2 = pick();
      for (var i = 0; i < n; i++) {
        var a = (i / n) * Math.PI * 2 + Math.random() * 0.15, v = sp * (0.6 + Math.random() * 0.5);
        sparks.push({ x: x, y: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v, life: 1, decay: 0.011 + Math.random() * 0.012, c: Math.random() < 0.7 ? c : c2, s: 1.3 + Math.random() * 1.3 });
      }
    }
    function tick(t) {
      raf = requestAnimationFrame(tick);
      if (!visible || document.hidden) { last = t; return; }
      if (last && t - last < 33) return;
      var dt = Math.min(t - (last || t), 66); last = t;
      acc += dt;
      if (!rockets.length && !sparks.length) {
        if (!cleared) { ctx.clearRect(0, 0, w, h); cleared = true; }
        if (acc > every) { acc = 0; launch(); }
        return;
      }
      cleared = false;
      if (acc > every) { acc = Math.random() * every * 0.35; launch(); if (Math.random() < 0.3) setTimeout(launch, 260); }
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fillStyle = 'rgba(0,0,0,0.34)'; ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'lighter';
      var i, r, p;
      for (i = rockets.length - 1; i >= 0; i--) {
        r = rockets[i]; r.y += r.vy * 2; r.vy *= 0.97;
        ctx.fillStyle = '#FFF3CE'; ctx.beginPath(); ctx.arc(r.x, r.y, 1.8, 0, 6.283); ctx.fill();
        if (r.y <= r.ty || r.vy > -1.2) { burst(r.x, r.y, r.c); rockets.splice(i, 1); }
      }
      for (i = sparks.length - 1; i >= 0; i--) {
        p = sparks[i]; p.x += p.vx * 2; p.y += p.vy * 2; p.vx *= 0.95; p.vy = p.vy * 0.95 + 0.07; p.life -= p.decay * 2;
        if (p.life <= 0) { sparks.splice(i, 1); continue; }
        ctx.globalAlpha = Math.max(p.life, 0); ctx.fillStyle = p.c;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.s * (0.5 + p.life * 0.5), 0, 6.283); ctx.fill();
      }
      ctx.globalAlpha = 1;
    }
    raf = requestAnimationFrame(tick);
    cv.__pb26stop = function () { cancelAnimationFrame(raf); ro.disconnect(); io.disconnect(); };
  }

  /* ---------------- slider (arrows, dots, autoscroll) ---------------- */
  function slider(root) {
    var rail = root.querySelector('[data-pb26-rail]');
    if (!rail) return;
    var prev = root.querySelector('[data-pb26-prev]'), next = root.querySelector('[data-pb26-next]');
    var dotsEl = root.querySelector('[data-pb26-dots]');
    var auto = root.getAttribute('data-autoscroll') || 'off';       /* off | step | continuous */
    var delay = (parseFloat(root.getAttribute('data-delay')) || 3) * 1000;
    var speed = parseFloat(root.getAttribute('data-speed')) || 40;    /* px per second, continuous mode */
    var loop = root.getAttribute('data-loop') !== 'false';
    var cards = Array.prototype.slice.call(rail.children);
    var paused = false, timer, raf, lastT = 0, userT;

    function active() { return rail.scrollWidth > rail.clientWidth + 4; }
    function stepW() { var c = cards[0]; return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 14) : rail.clientWidth; }
    function index() { return Math.round(rail.scrollLeft / (stepW() || 1)); }
    function buildDots() {
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      if (!active()) return;
      cards.forEach(function (c, i) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Go to item ' + (i + 1));
        b.addEventListener('click', function () { userPause(); rail.scrollTo({ left: i * stepW(), behavior: 'smooth' }); });
        dotsEl.appendChild(b);
      });
      update();
    }
    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      if (prev) prev.disabled = !loop && rail.scrollLeft <= 2;
      if (next) next.disabled = !loop && rail.scrollLeft >= max - 2;
      if (dotsEl) { var i = Math.min(index(), cards.length - 1); Array.prototype.forEach.call(dotsEl.children, function (d, k) { d.classList.toggle('is-active', k === i); }); }
    }
    function go(dir) {
      var max = rail.scrollWidth - rail.clientWidth;
      if (dir > 0 && rail.scrollLeft >= max - 4) { if (loop) rail.scrollTo({ left: 0, behavior: 'smooth' }); return; }
      if (dir < 0 && rail.scrollLeft <= 4) { if (loop) rail.scrollTo({ left: max, behavior: 'smooth' }); return; }
      rail.scrollBy({ left: dir * stepW(), behavior: 'smooth' });
    }
    function userPause() { paused = true; clearTimeout(userT); userT = setTimeout(function () { paused = false; }, 6000); }

    if (prev) prev.addEventListener('click', function () { userPause(); go(-1); });
    if (next) next.addEventListener('click', function () { userPause(); go(1); });
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) { rail.addEventListener(ev, userPause, { passive: true }); });
    rail.addEventListener('mouseenter', function () { paused = true; });
    rail.addEventListener('mouseleave', function () { paused = false; });
    new ResizeObserver(buildDots).observe(rail);

    var visible = false;
    new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(root);

    if (!reduce && auto === 'step') {
      timer = setInterval(function () { if (!paused && visible && active() && !document.hidden) go(1); }, delay);
    } else if (!reduce && auto === 'continuous') {
      var acc = 0;
      var frame = function (t) {
        raf = requestAnimationFrame(frame);
        var dt = Math.min(t - (lastT || t), 50); lastT = t;
        if (paused || !visible || !active() || document.hidden) return;
        var max = rail.scrollWidth - rail.clientWidth;
        acc += speed * dt / 1000;
        if (acc >= 1) {
          var px = Math.floor(acc); acc -= px;
          rail.style.scrollSnapType = 'none';
          rail.scrollLeft += px;
          if (rail.scrollLeft >= max - 1) { if (loop) rail.scrollLeft = 0; else paused = true; }
        }
      };
      raf = requestAnimationFrame(frame);
    }
    buildDots();
  }

  /* ---------------- copy code ---------------- */
  function copyBtn(b) {
    var label = b.querySelector('[data-pb26-copy-label]');
    var idle = b.getAttribute('data-idle') || 'Tap to copy', done = b.getAttribute('data-done') || 'Copied!';
    b.addEventListener('click', function () {
      var code = b.getAttribute('data-code') || '';
      function ok() { if (label) { label.textContent = done; clearTimeout(b.__t); b.__t = setTimeout(function () { label.textContent = idle; }, 1800); } }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, ok); else {
        var ta = document.createElement('textarea'); ta.value = code; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(ta); ok();
      }
    });
  }

  /* ---------------- sub navigation ---------------- */
  function nav(root) {
    var burger = root.querySelector('[data-pb26-burger]');
    if (burger) burger.addEventListener('click', function () {
      var open = root.classList.toggle('is-open'); burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    var links = Array.prototype.slice.call(root.querySelectorAll('.pb26-nav__link'));
    links.forEach(function (a) { a.addEventListener('click', function () { root.classList.remove('is-open'); }); });
    var map = [];
    links.forEach(function (a) {
      var href = a.getAttribute('href') || ''; var i = href.indexOf('#');
      if (i > -1 && href.length > i + 1) { var t = document.getElementById(href.slice(i + 1)); if (t) map.push({ a: a, t: t }); }
    });
    if (!map.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { map.forEach(function (m) { m.a.classList.toggle('is-active', m.t === e.target); }); }
      });
    }, { rootMargin: '-35% 0px -55% 0px' });
    map.forEach(function (m) { io.observe(m.t); });
  }

  /* Open the cart drawer once the Shopflo cart script (loaded on demand by the theme) is ready */
  function openCart(drawer, btn) {
    if (!drawer || !drawer.open) return;
    var t0 = Date.now();
    if (typeof window.pbLoadShopflo === 'function') { try { window.pbLoadShopflo(); } catch (e) {} }
    (function tryOpen() {
      if (typeof window.handleFloCartBtn === 'function' || typeof window.pbLoadShopflo !== 'function') {
        try { drawer.open(btn); } catch (e) {}
        return;
      }
      if (Date.now() - t0 > 15000) return;
      setTimeout(tryOpen, 100);
    })();
  }

  /* ---------------- add to cart ---------------- */
  function atc(btn) {
    var idle = btn.textContent;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.classList.contains('is-busy')) return;
      var id = parseInt(btn.getAttribute('data-variant'), 10);
      if (!id) return;
      btn.classList.add('is-busy'); btn.textContent = btn.getAttribute('data-adding') || 'Adding…';
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          btn.textContent = btn.getAttribute('data-added') || 'Added ✓';
          return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          var drawer = document.querySelector('m-cart-drawer');
          try { if (drawer && drawer.updateCartCount) drawer.updateCartCount(cart.item_count); } catch (x) {}
          try {
            if (drawer && drawer.onCartDrawerUpdate) { var p = drawer.onCartDrawerUpdate(false); }
          } catch (x) {}
          try { if (window.PubSub && window.MinimogTheme && window.MinimogTheme.pubSubEvents) window.PubSub.publish(window.MinimogTheme.pubSubEvents.cartUpdate, { source: 'pb26' }); } catch (x) {}
          openCart(drawer, btn);
          document.dispatchEvent(new CustomEvent('pb26:cart-add', { detail: cart }));
        })
        .catch(function (err) {
          btn.textContent = (err && (err.description || err.message)) ? 'Unavailable' : 'Try again';
        })
        .then(function () { setTimeout(function () { btn.classList.remove('is-busy'); btn.textContent = idle; }, 2200); });
    });
  }

  /* ---------------- video ---------------- */
  function video(v) {
    var m = v.getAttribute('data-src-m');
    if (m && window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
      while (v.firstChild) v.removeChild(v.firstChild);
      v.src = m; v.load();
    }
    if (v.hasAttribute('autoplay')) { v.muted = true; v.playsInline = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }

  function once(el, key, fn) { if (el.dataset[key]) return; el.dataset[key] = '1'; try { fn(el); } catch (e) { if (window.console) console.warn('[pb26]', e); } }

  function init(scope) {
    scope = scope || document;
    if (!reduce) scope.querySelectorAll('[data-pb26-fx]').forEach(function (c) { once(c, 'pb26', fireworks); });
    scope.querySelectorAll('[data-pb26-slider]').forEach(function (s) { once(s, 'pb26', slider); });
    scope.querySelectorAll('[data-pb26-copy]').forEach(function (b) { once(b, 'pb26', copyBtn); });
    scope.querySelectorAll('[data-pb26-nav]').forEach(function (n) { once(n, 'pb26', nav); });
    scope.querySelectorAll('[data-pb26-atc]').forEach(function (b) { once(b, 'pb26', atc); });
    scope.querySelectorAll('video[data-pb26-video]').forEach(function (v) { once(v, 'pb26', video); });
  }

  window.__pb26 = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
